import React, { useState } from "react";
import { Button } from "./Button";
import { Input } from "./Input";

/**
 * Dialog / modal shell. This is the surface only — parent handles visibility.
 * @param {Object} props
 * @param {string} [props.title]
 * @param {boolean} [props.destructive]
 */
export function Dialog({ title, destructive = false, className = "", children }) {
  return (
    <div className={`ds-dialog ${destructive ? "is-destructive" : ""} ${className}`.trim()}>
      {title && <div className="ds-dialog-title">{title}</div>}
      {children}
    </div>
  );
}

export function DialogBody({ children }) { return <div className="ds-dialog-body">{children}</div>; }
export function DialogActions({ children }) { return <div className="ds-dialog-actions">{children}</div>; }

/**
 * Destructive-confirmation dialog with typed-name confirmation input.
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.confirmToken — user must type this exactly to enable delete.
 * @param {()=>void} props.onConfirm
 * @param {()=>void} [props.onCancel]
 * @param {React.ReactNode} [props.body]
 */
export function DestructiveDialog({ title, confirmToken, onConfirm, onCancel, body }) {
  const [typed, setTyped] = useState("");
  const enabled = typed === confirmToken;
  return (
    <Dialog title={title} destructive>
      {body && <DialogBody>{body}</DialogBody>}
      <div className="ds-dialog-confirm-hint">Type <strong>{confirmToken}</strong> to confirm</div>
      <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={confirmToken} />
      <DialogActions>
        <Button variant="ghost" size="sm" onClick={onCancel}>Cancel</Button>
        <Button variant="danger" size="sm" disabled={!enabled} onClick={onConfirm}>Delete permanently</Button>
      </DialogActions>
    </Dialog>
  );
}
